import React from "react";
import { INotFound } from "./NotFound.interface";
import styles from './NotFound.module.scss';
import { isMobile } from '@/utils/hooks'
import Typography from "@mui/material/Typography";
import { Icons } from "@/components/atoms/icons";
import { Button } from "@toctoc/design-system";

export const NotFound = (dataNotFound: INotFound) => {

	const { buttonVisible = false } = dataNotFound;

	return (
		<div className={styles.contenedorNotFound}>
			<div className={styles['subContenedor']}>
				<Icons iconName="iconMagnifyingGlass" ></Icons>
				<Typography marginTop={2} variant="h5" className={isMobile() ? styles['titulo-mobile'] : styles['titulo']}>Lo sentimos, no encontramos propiedades con tus criterios de búsqueda.</Typography>
				<Typography marginTop={1} variant="subtitle1" className={isMobile() ? styles['subTitulo-mobile'] : styles['subTitulo']}>Los filtros no muestran resultados. Te invitamos a eliminar algunos y sigas buscando tu propiedad ideal.</Typography>

				{(buttonVisible) && <Button
					className={styles['btnClearFilters']}
					color="primary"
					href={'#'}
					size="medium"
					texto="Eliminar último filtro"
					variant="outlined"
				/>
				}
			</div>
		</div>
	);
};
